import WorkflowsPrivateView from './workflows-private-view';

export default WorkflowsPrivateView;